var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeroku(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 70,
    viewBox: "0 0 64 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.4211 0H6.38426C2.86218 0 0 2.81886 0 6.30492V63.7009C0 67.1811 2.86218 70 6.38426 70H57.4211C60.9441 70 63.7975 67.1811 63.7975 63.7009V6.30492C63.7975 2.81886 60.9441 0 57.4211 0ZM60.2528 63.7009C60.2528 65.2464 58.985 66.4975 57.4211 66.4975H6.38426C4.82129 66.4975 3.54463 65.2464 3.54463 63.7009V6.30492C3.54463 4.75362 4.82129 3.50058 6.38426 3.50058H57.4211C58.985 3.50058 60.2528 4.75362 60.2528 6.30492V63.7009ZM15.9493 59.504L23.9289 52.5009L15.9493 45.4997V59.504ZM44.7664 31.1275C43.3319 29.703 40.7129 28.0016 36.3328 28.0016C31.5272 28.0016 26.5775 29.2382 23.0397 30.3702V10.5036H15.9495V40.8584L20.96 38.6167C21.0433 38.5799 29.121 35.0038 36.3328 35.0038C39.9304 35.0038 40.7276 36.9598 40.7658 38.5944V59.504H47.8482V38.5044C47.856 38.055 47.8109 34.171 44.7664 31.1275ZM35.4442 21.8762H42.5345C45.7379 18.2923 47.3705 14.477 47.849 10.5029H40.7656C39.9763 14.4693 38.2299 18.2623 35.4442 21.8762Z",
    fill: "#6762A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroku);
export default __webpack_public_path__ + "static/media/heroku.13b3eb20043835c44f44e75dc7172c9c.svg";
export { ForwardRef as ReactComponent };